{
  "explain_version" : "1.18.63",
  "display_update_modal": false,
  "__comment__": "le module spécifique prend les valeurs, '', 'tenders', ou 'territory_intel'. Si la valeur est '' cela signifie que l'on affiche la modale pour tous les modules",
  "target_update_modal_module": "territory_intel",

  "__comment__": "__to use display_new_feature_explained_modal,you NEED to set display_update_modal to true__",
  "display_new_feature_explained_modal": false,
  "__comment__": "__for now on, new_feature_localstorage_item_name HAS to be unique for each new feature__",
  "new_feature_localstorage_item_name": "avis-attribution-mvp-renouvellement-modal-release",
  "__comment__": "le module spécifique prend les valeurs, '', 'tenders', ou 'territory_intel'. Si la valeur est '' cela signifie que l'on affiche la modale pour tous les modules",
  "target_new_feature_modal_module": "tenders",

  "other": "0"
}
